function enableDragScroll(selector) {
  document.querySelectorAll(selector).forEach((_el) => {
    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;

    const DRAG_THRESHOLD = 5; // px

    _el.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false;
      _el.classList.add('active');
      startX = e.pageX - _el.offsetLeft;
      scrollLeft = _el.scrollLeft;
    });

    _el.addEventListener('mouseleave', () => {
      isDown = false;
      _el.classList.remove('active');
    });

    _el.addEventListener('mouseup', () => {
      isDown = false;
      _el.classList.remove('active');
    });

    _el.addEventListener('mousemove', (e) => {
      if (!isDown) return;

      const x = e.pageX - _el.offsetLeft;
      const walk = x - startX;

      // detect real drag
      if (Math.abs(walk) > DRAG_THRESHOLD) {
        isDragging = true;
      }

      if (isDragging) {
        e.preventDefault(); // important
        _el.scrollLeft = scrollLeft - walk;
      }
    });

    // 🔥 block clicks if it was a drag
    _el.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true); // use capture phase
  });
}

// usage
enableDragScroll('.icons-container-scroll');
function openDrawerById(id) { 
  const drawer = document.querySelector(`.pdp-drawer[data-drawer-id="${id}"]`);
  const overlay = document.getElementById('drawerOverlay');
  if (drawer) {
    drawer.classList.add('open');
    overlay.classList.add('active');
  }
  
  if (drawer.classList.contains("has-reviews")) {
    loadReviewsEvents();
  }
}
function loadReviewsEvents() {
  const btnQuick = document.getElementById('btn-quick');
  const btnReviews = document.getElementById('btn-reviews');
  const el01 = document.querySelector('.reviews-widget .oke-w-header');
  const el02 = document.querySelector('.reviews-widget .oke-w-main');
  const el03 = document.querySelector('#filter-toggle');
  if (el03 && el03.getAttribute('aria-expanded') === 'true') {
    el03.click();
  }
  btnQuick.addEventListener('click', () => {
    btnQuick.classList.add('active');
    btnReviews.classList.remove('active');
    el01.style.display = 'block';
    el02.style.display = 'none';
  });
  btnReviews.addEventListener('click', () => {
    btnReviews.classList.add('active');
    btnQuick.classList.remove('active');

    // 2. Toggle Content
    el01.style.display = 'none';
    el02.style.display = 'block';
  });
}
document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-drawer-id]');
  if (btn && btn.classList.contains('accordion-toggle')) {
    const id = btn.getAttribute('data-drawer-id');
    openDrawerById(id);
  }
});

function closeDrawer() {
  document.querySelectorAll('.pdp-drawer').forEach(d => d.classList.remove('open'));
  document.getElementById('drawerOverlay').classList.remove('active');
  document.body.classList.remove('phone-selector-open');
}
 
class SliderComponentTop extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.enableSliderLooping = false;
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.currentPage = 0;
    this.activeItem = null; 

    if (!this.slider || !this.nextButton) return;

    // Ensure CSS rendering is complete before calculating heights
    requestAnimationFrame(() => {
      this.initPages();
      
      let resizeTimer;
      const resizeObserver = new ResizeObserver(() => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.initPages(), 50);
      });
      resizeObserver.observe(this.slider);
    });

    this.slider.addEventListener('scroll', this.update.bind(this), { passive: true });
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    // Re-query the elements in case they were injected dynamically
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    
    if (this.sliderItemsToShow.length < 2) return;

    const isRow = window.getComputedStyle(this.slider).flexDirection === 'row';
    this.sliderItemOffset = isRow 
      ? this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft
      : this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;

    this.slidesPerPage = isRow
      ? Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset)
      : Math.floor((this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset);

    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    
    this.update(true); 
  }

  update(force = false) {
    if (!this.slider || !this.nextButton || !this.sliderItemOffset) return;

    const isRow = window.getComputedStyle(this.slider).flexDirection === 'row';
    const scrollPos = isRow ? this.slider.scrollLeft : this.slider.scrollTop;
    const newPage = Math.round(scrollPos / this.sliderItemOffset) + 1;

    if (this.currentPage !== newPage || force) {
      this.currentPage = newPage;

      if (this.activeItem) {
        this.activeItem.classList.remove('is-active');
      }

      const activeIndex = this.currentPage - 1;
      this.activeItem = this.sliderItemsToShow[activeIndex];
      
      if (this.activeItem) {
        this.activeItem.classList.add('is-active');
      }
    }

    if (this.enableSliderLooping) return;

    if (this.slider.scrollTop <= 5) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.slider.scrollTop + this.slider.clientHeight >= this.slider.scrollHeight - 5) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }
  isSlideVisible(element, offset = 0) {
    if (!this.slider || !element) return false;
    const isRow = window.getComputedStyle(this.slider).flexDirection === 'row';
    if (isRow) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return (
          element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
          element.offsetLeft >= this.slider.scrollLeft
        );
    } else {
        const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
        return (
          element.offsetTop + element.clientHeight <= lastVisibleSlide &&
          element.offsetTop >= this.slider.scrollTop
        );
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const stepHeight = this.sliderItemOffset; 
    const step = parseInt(event.currentTarget.dataset.step) || 1;

    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollTop + (step * stepHeight)
        : this.slider.scrollTop - (step * stepHeight);

    this.slider.scrollTo({
      top: this.slideScrollPosition,
      behavior: 'smooth',
    });
  }
}

if (!customElements.get('slider-component-top')) {
  customElements.define('slider-component-top', SliderComponentTop);
}


if (!customElements.get('product-upsell')) {
class ProductUpsell extends HTMLElement {
    constructor() {
        super();
        this.handleVariantChange = this.handleVariantChange.bind(this);
    }
    connectedCallback() {
        this.initProducts();
        this.upsellProductWatchers();
        this.initProtectorUpsell();
        enableDragScroll('.cart-modal-upsell .product-upsell-container');
    }

    disconnectedCallback() {
        document.removeEventListener('variant-change', this.handleVariantChange);
    }
    getSizedImageUrl(src, size) {
        if (!src) return src;
        return src.replace(/(\.[^.]*?)(\?v=.*)?$/, `_${size}$1$2`);
    }

    initProtectorUpsell() {
        this.protectorUpsell = Array.from(this.querySelectorAll('.upsell-product')).find((el) => {
            return el.classList.contains('protector-upsell')
        });
        if (!this.protectorUpsell) return;
        document.addEventListener('variant-change', this.handleVariantChange);
    }

    matchVariant(product, targetModel, targetColor) {
        if (!product || !product.data || !product.data.variants) return '';
        let bestVariantId = '';
        const lowerModel = targetModel ? targetModel.toLowerCase().trim() : '';
        const lowerColor = targetColor ? targetColor.toLowerCase().trim() : '';
        Object.keys(product.data.variants).some(title => {
            const parts = title.toLowerCase().split(' / ').map(p => p.trim());
            
            let matchesModel = true;
            if (lowerModel) {
                 matchesModel = parts.some(p => {
                     if (p === lowerModel) return true;
                     const subParts = p.split('/').map(s => s.trim());
                     return subParts.includes(lowerModel);
                 });
            }

            let matchesColor = true;
            if (lowerColor) {
                 matchesColor = parts.includes(lowerColor);
            }

            if (matchesModel && matchesColor) {
                bestVariantId = product.data.variants[title];
                return true;
            }
            return false;
        });
        if (!bestVariantId && lowerModel) {
             Object.keys(product.data.variants).some(title => {
                const parts = title.toLowerCase().split(' / ').map(p => p.trim());
                if (parts.some(p => p === lowerModel || p.split('/').map(s => s.trim()).includes(lowerModel))) {
                    bestVariantId = product.data.variants[title];
                    return true;
                }
                return false;
             });
        }
        if (!bestVariantId && lowerColor) {
             Object.keys(product.data.variants).some(title => {
                const parts = title.toLowerCase().split(' / ').map(p => p.trim());
                if (parts.includes(lowerColor)) {
                    bestVariantId = product.data.variants[title];
                    return true;
                }
                return false;
             });
        }
        return bestVariantId;
    }

    handleVariantChange(e) {
        const variant = e.detail;
        if (!variant) return;
        const parentOptions = [variant.option1, variant.option2, variant.option3].map(o => o ? o.toLowerCase().trim() : null).filter(o => o);

        this.products.forEach((product) => {
            if (!product.hasModels && !product.hasProductTypes) return;
            let matchedModel = '';
            parentOptions.forEach(opt => {
                if (product.models && product.models.some(m => m.toLowerCase().trim() === opt)) {
                    matchedModel = opt;
                }
            });
            if (matchedModel) {
                let currentColor = '';
                const activeColorInput = product.querySelector('.upsell-product-colour input:checked');
                if (activeColorInput) {
                    currentColor = activeColorInput.value.split(' / ')[0].trim().toLowerCase();
                }
                const bestVariantId = this.matchVariant(product, matchedModel, currentColor);
                if (bestVariantId) {
                    if (product.checkbox) {
                        product.checkbox.value = bestVariantId;
                    }
                    product.classList.remove('d-none');
                    const variantImg = product.data.images[bestVariantId];
                    if (variantImg && product.img) {
                        const src50 = this.getSizedImageUrl(variantImg, "50x50");
                        const src185 = this.getSizedImageUrl(variantImg, "185x185");
                        
                        const desktopImg = product.querySelector(".img-desktop");
                        const mobileImg = product.querySelector(".img-mobile");
                        if (desktopImg) {
                            desktopImg.src = src185;
                            desktopImg.dataset.defaultSrc = src185;
                        }
                        if (mobileImg) {
                            mobileImg.src = src50;
                            mobileImg.dataset.defaultSrc = src50;
                        }
                    }
                    if (product.modelInput) {
                        const properModel = product.models.find(m => m.toLowerCase().trim() === matchedModel);
                        product.modelInput.value = properModel || matchedModel;
                    }
                } else {
                    product.classList.add('d-none');
                }
            } else {
                product.classList.add('d-none');
                if (product.checkbox && product.checkbox.checked) {
                    product.checkbox.checked = false;
                    product.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        });
    }
    initProducts() {
        const productNodes = this.querySelectorAll(".upsell-product");
        this.products = [];
        productNodes.forEach((product) => {
            const jsonScript = product.querySelector("[data-upsell-product]");
            if (!jsonScript) return;
            product.data = JSON.parse(jsonScript.innerText);
            product.checkbox = product.querySelector(".upsell-product-selection");
            product.modelInput = product.querySelector(".upsell-model");
            product.img = product.querySelector("img");
            product.colourInputs = product.querySelectorAll(".upsell-product-colour input");
            const modelOptIndex = (product.data.options || []).findIndex(opt => {
                const o = opt.toLowerCase().trim();
                return o === 'model' || o === 'phone type' || o === 'phone model';
            });
            product.hasModels = modelOptIndex !== -1;
            product.hasProductTypes = false;
            if (product.hasModels && product.data.variants) {
                const models = new Set();
                Object.keys(product.data.variants).forEach(title => {
                    const parts = title.split(' / ').map(p => p.trim());
                    if (parts[modelOptIndex]) {
                        parts[modelOptIndex].split('/').forEach(m => models.add(m.trim()));
                    }
                });
                product.models = Array.from(models);
            }
            if (product.colourInputs && product.colourInputs.length > 0 && product.data.variants) {
                product.colourInputs.forEach((input) => {
                    input.addEventListener("change", (event) => {
                        if (input.checked) {
                            const colorValue = input.value.split(' / ')[0].trim().toLowerCase();
                            const currentModel = product.modelInput ? product.modelInput.value.toLowerCase().trim() : '';
                            const bestVariantId = this.matchVariant(product, currentModel, colorValue);
                            if (bestVariantId) {
                                const variantImg = product.data.images[bestVariantId];
                                if (variantImg && product.img) {
                                    const src50 = this.getSizedImageUrl(variantImg, "50x50");
                                    const src185 = this.getSizedImageUrl(variantImg, "185x185");
                                    const desktopImg = product.querySelector(".img-desktop");
                                    const mobileImg = product.querySelector(".img-mobile");
                                    if (desktopImg) desktopImg.src = src185;
                                    if (mobileImg) mobileImg.src = src50;
                                }
                                if (product.checkbox) {
                                    product.checkbox.value = bestVariantId;
                                    if (event && event.isTrusted) {
                                        product.checkbox.checked = true;
                                        product.checkbox.dispatchEvent(new Event('change', { bubbles: true }));
                                    }
                                }
                            }
                        }
                    });
                });
                const activeColor = product.querySelector(".upsell-product-colour input:checked");
                if (activeColor) {
                    activeColor.dispatchEvent(new Event('change', { bubbles: false }));
                }
            }
            this.products.push(product);
        });
    }
    upsellProductWatchers() {
        const inputs = this.querySelectorAll(".upsell-product-selection");
        inputs.forEach((input) => {
            input.addEventListener("change", () => {
                const event = new Event('product-upsell:change', { bubbles: true });
                document.dispatchEvent(event);
            });
        });
    }
}
    customElements.define('product-upsell', ProductUpsell);
}